export const dummySchools = {
  data: [
    {
      id: "1",
      name: "Green Valley School",
      address: "Sector 45, Gurgaon",
      pincode: "122003",
      landmark: "Near Huda City Centre",

      // ✅ match mapped keys
      phone: "9876543210",
      email: "school1@gmail.com",

      createdOn: "2026-03-01",
      status: 1,

      latitude: "28.4595",
      longitude: "77.0266",
    },
    {
      id: "2",
      name: "Delhi Public School",
      address: "Sector 50, Gurgaon",
      pincode: "122018",
      landmark: "",

      phone: "9123456780",
      email: "school2@gmail.com",

      createdOn: "2026-03-05",
      status: 0,

      latitude: "28.4089",
      longitude: "77.0400",
    },
  ],
  total: 2,
};